import { styled, Subheader } from '@streem/ui-react';
export const ModelSerialWrapper = styled.section(({ hasFootbar = false, theme }) => ({
    borderBottom: hasFootbar ? `1px solid ${theme.colors.grey10}` : '',
}));
export const DetectionText = styled.span(({ theme }) => `
    display: inline-block;
    align-self: center;
    justify-self: start;
    background: ${theme.colors.grey05};
    border-radius: 4px;
    color: rgba(44, 44, 44, 0.73);
    padding: 4px 6px;
    text-decoration: none;
    font-weight: 600;
`);
export const DetectionLink = styled.a(({ theme }) => `
    display: inline-block;
    align-self: center;
    justify-self: start;
    background: ${theme.colors.grey05};
    border-radius: 4px;
    color: ${theme.colors.azure};
    padding: 4px 6px;
    font-weight: 600;
    text-decoration: none;
    :hover {
        background: ${theme.colors.grey10};
    }
`);
export const DetectionList = styled.div({
    display: 'grid',
    gridTemplateColumns: '130px auto',
    gridAutoRows: '32px',
    gridRowGap: '8px',
    height: '100%',
    maxHeight: '255px',
    overflow: 'auto',
    '::-webkit-scrollbar': {
        WebkitAppearance: 'none',
        width: '7px',
    },
    '::-webkit-scrollbar-thumb': {
        borderRadius: '4px',
        backgroundColor: 'rgba(0, 0, 0, .5)',
        boxShadow: '0 0 1px rgba(255, 255, 255, .5)',
    },
    borderBottom: `6px solid #fff`,
    borderTop: `6px solid #fff`,
});
export const DetectionTypeLabel = styled.span({
    display: 'inline-block',
    width: '130px',
    alignSelf: 'center',
    justifySelf: 'start',
});
export const FeedbackHeaderContainer = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});
export const DetectionInputContainer = styled.div({
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
});
export const DetectionSubheader = styled(Subheader) `
    margin-bottom: 8px;
    line-height: 25px;
`;
//# sourceMappingURL=model_serial_list_styles.js.map